import Button from 'components/StyledButton/StyledButton';
import styled from 'styled-components';

const StyledActionButton = styled(Button)`
    height: fit-content;
    margin: auto;
`;

export default StyledActionButton;
